import isUndefined from "lodash/isUndefined";
import { useEffect, useState } from "react";

import NotificationsUpdater from "components/background/CurrentUser/NotificationsUpdater";
import useCurrentUser from "hooks/fragments/useCurrentUser";

export default function NotificationIndicator({
  initialNotificationsCount = 0,
}: {
  initialNotificationsCount?: number;
}) {
  const [hasNotifications, setHasNotifications] = useState(
    initialNotificationsCount > 0,
  );
  const currentNotificationsCount: number = useCurrentUser(
    u => u.notificationsCount,
  );

  useEffect(() => {
    if (!isUndefined(currentNotificationsCount)) {
      setHasNotifications(currentNotificationsCount > 0);
    }
  }, [currentNotificationsCount]);

  return (
    <>
      <NotificationsUpdater />
      {hasNotifications ? (
        <span className="absolute rounded-full bottom-1 right-1 bg-red-500 p-1" />
      ) : (
        <> </>
      )}
    </>
  );
}
